import React from "react";
import { Button } from "reactstrap";
import useQRCode from "../hooks/useQRCode";

const QRDownloadButtons = ({ value, onBeforeGenerate }) => {
  const { toPngDataUrl } = useQRCode();

  const handleCopy = async () => {
    if (!onBeforeGenerate || onBeforeGenerate()) {
      try {
        await navigator.clipboard.writeText((value.url || "").trim());
        alert("คัดลอกลิงก์แล้ว");
      } catch {
        alert("ไม่สามารถคัดลอกได้");
      }
    }
  };

  const handleDownloadPng = async () => {
    if (!onBeforeGenerate || onBeforeGenerate()) {
      const dataUrl = await toPngDataUrl({
        text: (value.url || "").trim(),
        width: value.size,
        margin: value.margin,
        color: { dark: value.fgColor, light: value.bgColor },
        errorCorrectionLevel: value.ecc,
        logoDataUrl: value.logoDataUrl || "",
      });
      const a = document.createElement("a");
      a.href = dataUrl;
      a.download = "qr.png";
      a.click();
    }
  };

  const handlePrint = async () => {
    if (!onBeforeGenerate || onBeforeGenerate()) {
      const dataUrl = await toPngDataUrl({
        text: (value.url || "").trim(),
        width: value.size,
        margin: value.margin,
        color: { dark: value.fgColor, light: value.bgColor },
        errorCorrectionLevel: value.ecc,
        logoDataUrl: value.logoDataUrl || "",
      });
      const win = window.open("", "_blank", "width=800,height=800");
      if (!win) return;
      win.document.write(`
        <html>
          <head><title>Print QR</title></head>
          <body style="display:flex;align-items:center;justify-content:center;margin:0;padding:0">
            <img id="qrimg" src="${dataUrl}" style="max-width:90vw;max-height:90vh" />
            <script>
              const img = document.getElementById('qrimg');
              img.onload = function(){ window.print(); };
            <\/script>
          </body>
        </html>
      `);
      win.document.close();
      win.focus();
    }
  };

  return (
    <div className="d-flex flex-wrap gap-2 mt-3">
      <Button color="dark" onClick={handleDownloadPng}>
        ดาวน์โหลด PNG
      </Button>
      <Button color="secondary" onClick={handlePrint} outline>
        พิมพ์
      </Button>
      <Button color="secondary" onClick={handleCopy} outline>
        คัดลอกลิงก์
      </Button>
    </div>
  );
};

export default QRDownloadButtons;
